<template>
  <div class="dettaglio-contestazione" v-loading="loading">
    <div class="header-tab row row-custom">
      <div class="col-2 back-div">
        <icon name="riv-arrow" scale="3" class="back pointer" flip="horizontal" @click.native="goBack" />
      </div>
      <div class="col-20">
        <div class="my-label col-24 no-padding">
          {{ $t('dettaglioContestazione.contestazione').toUpperCase() + ' ' + contestazione.numCon }}
        </div>
        <div class="sotto-label col-24 no-padding">

        </div>
      </div>
    </div>
    <div class="row row-custom">
      <div class="sx col-xl-16 col-24">
        <div class="descrizione col-24 no-padding">
          {{ contestazione.annoOrd + ' /' + contestazione.numOrd }}
          <el-tooltip class="item" effect="dark" :content="$t('dettaglioContestazione.note')" placement="top">
            <icon name="riv-addnotes" scale="1.5" class="pointer" @click.native="goToNote()" />
          </el-tooltip>
        </div>
        <div class="testata-sx">
          <div class="row row-custom">
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.soc') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-input v-model="contestazione.desSoc" :maxlength="20" class="custom-input" :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.mag') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-input v-model="contestazione.desMag" :maxlength="20" class="custom-input" :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.statoCon') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-input v-model="contestazione.statoCon" :maxlength="20" class="custom-input"
                    :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.dataCont') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-date-picker :disabled="disabled" v-model="contestazione.dataTimeCon" type="datetime"
                    format="dd/MM/yyyy HH:mm" value-format="yyyyMMddHH:mm" placeholder="" class="custom-date-picker" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.nominativo') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-input v-model="contestazione.nominativo" :maxlength="20" class="custom-input"
                    :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.mansione') }}
                </div>
                <div class="testata-value col-14 no-padding">
                  <el-input v-model="contestazione.mansione" :maxlength="20" class="custom-input"
                    :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.note') }}
                </div>
                <div class="col-14 textarea no-padding">
                  <el-input v-model="contestazione.note" type="textarea" resize="none" class="custom-input" :rows="5"
                    :disabled="disabled" />
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-24">
              <div class="row row-custom elemento">
                <div class="testata-label col-10">
                  {{ $t('dettaglioContestazione.noteDisp') }}
                </div>
                <div class="col-14 textarea no-padding">
                  <el-input v-model="contestazione.noteDisp" type="textarea" resize="none" class="custom-input"
                    :rows="5" :disabled="disabled" />
                </div>
              </div>
            </div>

            <el-table :data="contestazione.docs" class="col-24 no-padding custom-table" :row-class-name="getRowClass">
              <el-table-column label="#" width="30">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="tipoDoc" :label="$t('dettaglioContestazione.tipoDocumento')" min-width="140" />
              <el-table-column header-align="center" align="center" :label="$t('dettaglioContestazione.caricatoIl')"
                width="140">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.dataCar) ? moment(scope.row.dataCar, 'YYYYMMDD').format('DD/MM/YYYY') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" :label="$t('dettaglioContestazione.approvatoIl')"
                width="140">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ (scope.row.dataApp && scope.row.dataApp != '00000000') ? moment(scope.row.dataApp,
                      'YYYYMMDD').format('DD/MM/YYYY') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="" width="100">
                <template slot-scope="scope">
                  <div class="icone-div" v-if="scope.row.elaborato == '1'">
                    <icon name="riv-searchPas" scale="1" class="icona pointer"
                      v-if="keyDocSelected === '' || keyDocSelected !== scope.row.keyDoc"
                      @click.native="previewDocumento(scope.row)" />
                    <icon name="riv-searchPas" scale="1" class="icona pointer" v-else
                      @click.native="deleteDocPreview(scope.row)" />
                    <icon name="riv-downloadPas" scale="1" class="icona pointer"
                      @click.native="downloadDoc(scope.row)" />
                  </div>
                  <div class="icone-div" v-else>
                    <el-tooltip class="item" effect="dark" :content="$t('dettaglioContestazione.inElaborazione')"
                      placement="left">
                      <icon name="riv-hourglass" scale="1" class="icona pointer" />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="dx col-xl-8 col-24" v-loading="loadingPreview">
        <div class="col-24 no-padding titolo">
          {{ $t('dettaglioContestazione.tipoDocumento') }}
        </div>
        <div class="info-upload col-24 no-padding" v-if="ifUpload">
          <div>
          </div>
          <el-button class="custom-button" type="primary" @click="uploadDoc()" :disabled="!fileToUpload">
            {{ $t('dettaglioContestazione.upload').toUpperCase() }}
          </el-button>
        </div>
        <div class="info-download col-24 no-padding" v-else>
          <div class="nome-doc">
            {{ docPreview.tipoDoc ? docPreview.tipoDoc : '-' }}
          </div>
          <el-button class="custom-button" type="primary" @click="downloadDoc(docPreview)"
            :disabled="(!docPreview.keyDoc)">
            {{ $t('dettaglioContestazione.download').toUpperCase() }}
          </el-button>
        </div>
        <div class="col-24 no-padding nome-file" v-if="fileToUpload">
          {{ fileToUpload ? fileToUpload.name : '' }}
        </div>
        <div class="row row-custom doc-container" :style="[fileToUpload ?
          { minHeight: '335px', height: (contenitoreHeight - 260) + 'px', paddingTop: '5px', maxHeight: '640px' }
          : { minHeight: '335px', height: (contenitoreHeight - 260) + 'px', paddingTop: '15px', maxHeight: '640px' }
        ]">
          <div class="doc" v-if="ifUpload && !fileToUpload">
            <el-upload class="avatar-uploader" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx" action=""
              :show-file-list="false" :on-change="changeUploadList" :auto-upload="false">
              <div class="add">
                <i class="el-icon-circle-plus add-icon" />
                <div class="el-upload__text">{{ $t('dettaglioContestazione.nuovoDoc') }}</div>
              </div>
            </el-upload>
          </div>
          <div class="file-preview" v-if="ifUpload && fileToUpload">
            <icon name="riv-delete2" scale="1.5" class="delete pointer" @click.native="deleteDocPreview" />
            <pdf :src="filePreview" :style="{ minHeight: '328px', height: (contenitoreHeight - 267) + 'px' }"
              v-if="filePreview" />
            <img :src="imgPreview" :style="{ minHeight: '328px', height: (contenitoreHeight - 267) + 'px' }" v-else>
          </div>
          <div class="preview-img" v-if="!ifUpload">
            <img @click="downloadDoc(docPreview)" :src="imageUrl"
              :style="{ minHeight: '318px', height: (contenitoreHeight - 277) + 'px' }" class="pointer">
          </div>
        </div>
      </div>

    </div>

    <el-dialog :title="$t('dettaglioContestazione.note').toUpperCase()" :visible.sync="noteVisible"
      :append-to-body="true" :close-on-click-modal="false"
      custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-2 col-20 modal-note">

      <div class="info-note col-24 no-padding">
        {{ $t('dettaglioContestazione.noteInfo') }}
      </div>
      <div class="col-24 textarea no-padding">
        <el-input v-model="noteTemp" type="textarea" resize="none" class="custom-input" :maxlength="1000"
          :disabled="!ifNote" />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" @click="closeNote">{{ $t('dettaglioContestazione.annulla').toUpperCase()
            }}</el-button>
          <el-button class="custom-button" type="primary" @click="salvaNote" :disabled="!ifNote">{{
            $t('dettaglioContestazione.salva').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import { bus } from '@/components/Bus.js'
import moment from 'moment'
import numeral from 'numeral'
import pdf from 'vue-pdf'

export default {
  components: { pdf },
  name: 'DettaglioContestazione',
  props: {
    contenitoreHeight: {
      type: Number,
      required: true,
      default: 550
    }
  },
  i18n: {
    messages: {
      it_IT: {
        dettaglioContestazione: {
          contestazione: 'Contestazione N. ',
          ordine: 'Ordine',
          soc: 'Società',
          mag: 'Magazzino',
          dataCont: 'Data Contestazione',
          nominativo: 'Nominativo',
          mansione: 'Mansione',
          statoCon: 'Stato',
          note: 'Note',
          noteInfo: 'A seguito di quanto riscontrato nella contestazione, inserire le note in merito alle azioni da intraprendere:',
          noteDisp: 'Note Disp',
          caricatoIl: 'Caricato Il',
          approvatoIl: 'Approvato Il',
          tipoDocumento: 'Tipo Documento',
          download: 'Download',
          upload: 'Upload',
          annulla: 'Annulla',
          salva: 'Salva',
          caricamentoOK: 'Documento salvato correttamente',
          caricamentoKO: 'Errore di caricamento',
          nuovoDoc: 'Selezionare un documento da caricare',
          inElaborazione: 'Documento in elaborazione, sarà disponibile a breve.'
        }
      },
      fr_FR: {
        dettaglioContestazione: {
          contestazione: 'Requête de devis Nr. ',
        }
      },
      es_ES: {
        dettaglioContestazione: {
          contestazione: 'Petición de oferta Nº. '
        }
      },
      de_DE: {
        dettaglioContestazione: {
          contestazione: 'Angebotsanforderung Nr. '
        }
      },
      en_GB: {
        dettaglioContestazione: {
          contestazione: 'Richiesta di Quotazione N. '
        }
      },
    }
  },
  computed: {
  },
  data() {
    return {
      codLang: sessionStorage.getItem('codLang'),
      moment: moment,
      loading: true,
      loadingPreview: false,
      form: {},
      contestazione: {},
      imageUrl: 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png',
      ifNote: false,
      ifUpload: false,
      docPreview: {},
      filePreview: null,
      fileToUpload: null,
      imgPreview: 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png',
      pag_for: 10,
      currentPage: 1,
      nrPages: 0,
      nrItems: 0,
      disabled: true,
      noteVisible: false,
      noteTemp: '',
      keyDocSelected: ''
    }
  },
  mounted: function () {
    bus.$on('changeLanguage', () => {
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
    })
  },
  activated: function () {
    this.init()
  },
  deactivated: function () {
    this.resetDati()
  },
  methods: {
    resetDati: function () {
      this.$set(this, 'form', {})
      this.$set(this, 'loading', true)
      this.$set(this, 'loadingPreview', false)
      this.$set(this, 'contestazione', {})
      this.$set(this, 'imageUrl', 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png')
      this.$set(this, 'ifUpload', false)
      this.$set(this, 'docPreview', {})
      this.$set(this, 'filePreview', null)
      this.$set(this, 'fileToUpload', null)
      this.$set(this, 'imgPreview', 'static/img/anteprima_' + sessionStorage.getItem('codLang') + '.png')
      this.$set(this, 'currentPage', 1)
      this.$set(this, 'nrPages', 0)
      this.$set(this, 'nrItems', 0)
      this.$set(this, 'disabled', true)
      this.$set(this, 'noteVisible', false)
      this.$set(this, 'noteTemp', '')
    },
    init: function () {
      this.$store.dispatch('ifObject', 'CON_Contestazione')
        .then((ifQuotazione) => {
          if (ifQuotazione) {
            let form = this.$store.state.CON_Ricerca
            let contestazione = this.$store.state.CON_Contestazione
            this.$set(this, 'form', form)
            this.loadContestazione(contestazione)
          } else {
            this.$router.push({ name: 'CONElenco' })
          }
        })
    },
    goBack: function () {
      this.$router.push({ name: 'CONElenco' })
    },
    getRowClass: function ({ row, rowIndex }) {
      if (row.keyDoc === this.keyDocSelected) {
        return 'evidenziato'
      }
    },
    goToUpload: function () {
      this.deleteDocPreview()
      this.$set(this, 'ifUpload', true)
    },
    goToNote: function () {
      this.$set(this, 'noteTemp', this.contestazione.noteForn)
      this.$set(this, 'noteVisible', true)
    },
    salvaNote: function () {
      /*let formData = new FormData()
      formData.append('codSoc', this.contestazione.codSoc)
      formData.append('codMag', this.contestazione.codMag)
      formData.append('annoOrd', this.contestazione.annoOrd)
      formData.append('numOrd', this.contestazione.numOrd)
      formData.append('fornitore', this.contestazione.fornitore)
      formData.append('numCon', this.contestazione.numCon)
      formData.append('noteForn', this.noteTemp)
      formData.append('tipoSave', "S")*/
      let data = {
        codSoc: this.contestazione.codSoc,
        codMag: this.contestazione.codMag,
        annoOrd: this.contestazione.annoOrd,
        numOrd: this.contestazione.numOrd,
        fornitore: this.contestazione.fornitore,
        numCon: this.contestazione.numCon,
        noteForn: this.noteTemp,
        tipoSave: 'S'
      }

      this.$http.post('contestazioni/savenote', data, {
        params: {
          codLang: this.codLang,
          codForn: this.form.codForn,
          country: this.form.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.$set(this, 'noteVisible', false)
            this.loadContestazione(this.contestazione)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'loading', false)
          }
        })
    },
    closeNote: function () {
      this.$set(this, 'noteVisible', false)
    },
    loadContestazione: function (contestazione) {
      this.$http.get('contestazioni/contestazione', {
        params: {
          codLang: this.codLang,
          codForn: this.form.codForn,
          country: this.form.country,
          fornitore: contestazione.fornitore,
          codSoc: contestazione.codSoc,
          codMag: contestazione.codMag,
          annoOrd: contestazione.annoOrd,
          numOrd: contestazione.numOrd,
          numCon: contestazione.numCon
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'contestazione', response.body.data)
            this.$set(this.contestazione, 'dataTimeCon', contestazione.dataCon + contestazione.oraCon)
            this.$set(this, 'ifNote', response.body.data.seNote === '1')
            this.$set(this, 'ifUpload', response.body.data.seUpload === '1')
            this.$set(this, 'loading', false)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'loading', false)
          }
        })
    },
    previewDocumento: function (doc) {
      this.deleteDocPreview()
      this.$set(this, 'loadingPreview', true)
      this.$set(this, 'ifUpload', false)
      this.$set(this, 'docPreview', doc)
      this.$http.get('accessostabilimenti/preview', {
        params: {
          container: doc.idCli + doc.idApp,
          dKey: doc.keyDoc
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'imageUrl', 'data:image/jpeg;base64,' + response.body.data.file)
          } else {
            this.$set(this, 'imageUrl', 'static/img/anteprima_' + this.codLang + '.png')
            // this.$set(this, 'docPreview', {})
          }
          this.$set(this, 'loadingPreview', false)
          this.$set(this, 'keyDocSelected', doc.keyDoc)
        })
    },
    downloadDoc: function (doc) {
      if (doc.keyDoc) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAccessoStabilimenti + 'print/doc?idCli=' + doc.idCli + '&idApp='
                + doc.idApp + '&keyDoc=' + doc.keyDoc + '&quality='+ process.env.qualityCM
                + '&token=' + response.body.wsToken)
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    },
    changeUploadList: function (file, fileList) {
      if (file.raw.type === 'application/pdf') {
        let reader = new FileReader()
        reader.onloadend = () => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '')

          this.$set(this, 'filePreview', 'data:application/pdf;base64, ' + base64String)
        }
        reader.readAsDataURL(file.raw)
      } else if (file.raw.type.indexOf('image') >= 0) {
        let array = file.name.split('.')
        let ext = array[array.length - 1]
        let reader = new FileReader()
        reader.onloadend = () => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '')

          this.$set(this, 'imgPreview', 'data:image/' + ext + ';base64, ' + base64String)
        }
        reader.readAsDataURL(file.raw)
      } else {
        this.$set(this, 'imgPreview', 'static/img/anteprima_' + this.codLang + '.png')
      }
      this.$set(this, 'fileToUpload', file)
    },
    deleteDocPreview: function () {
      this.$set(this, 'ifUpload', this.contestazione.seUpload === '1')
      this.$set(this, 'keyDocSelected', '')
      this.$set(this, 'fileToUpload', null)
      this.$set(this, 'filePreview', null)
      this.$set(this, 'imgPreview', 'static/img/anteprima_' + this.codLang + '.png')
      this.$set(this, 'imageUrl', 'static/img/anteprima_' + this.codLang + '.png')
      this.$set(this, 'docPreview', {})
    },
    uploadDoc: function () {
      this.$set(this, 'loading', true)

      let formData = new FormData()
      formData.append('csta', this.form.country)
      formData.append('csoc', this.contestazione.codSoc)
      formData.append('cmag', this.contestazione.codMag)
      formData.append('aord', this.contestazione.annoOrd)
      formData.append('nord', this.contestazione.numOrd)
      formData.append('ddoc', moment().format('YYYYMMDD'))    // Data di caricamento OGGI
      formData.append('cfor', this.contestazione.fornitore)
      formData.append('ncon', this.contestazione.numCon)
      formData.append('ccon', this.contestazione.codTipoCon)
      formData.append('cdsp', this.contestazione.codDisp)
      formData.append('cdoc', '03')
      formData.append('file', this.fileToUpload.raw)

      this.$http.post('contestazioni/doc', formData, {
        params: {
          codLang: this.codLang,
          codForn: this.form.codForn,
          country: this.form.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: this.$t('dettaglioContestazione.caricamentoOK'),
              type: 'success',
              duration: process.env.duration
            })
            this.deleteDocPreview()
            this.loadContestazione(this.contestazione)
          } else {
            this.$message({
              showClose: true,
              message: this.$t('dettaglioContestazione.caricamentoKO'),
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'loading', false)
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../../assets/less/general.less";

.salva-quotazioni {
  .el-message-box__content {
    padding: 15px 5px 25px 5px;

    .el-message-box__message {
      padding-left: 40px;
      padding-right: 0;
    }
  }
}

.modal-note {
  textarea {
    height: 180px;
  }

  .info-note {
    .set-font(@color: @grayMedium, @size: 14px, @family: 'os-regular');
    margin-bottom: 10px;
  }
}

.dettaglio-contestazione {
  .header-tab {
    height: 70px;
    text-align: center;
    margin-bottom: 5px;

    .back-div {
      line-height: 70px;
      text-align: left;
    }

    .back {
      color: @greenRiva;
    }

    .my-label {
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva, @size: 21px, @family: 'os-semibolditalic');
      letter-spacing: 2px;
    }

    .sotto-label {
      .set-font(@color: @greenRiva, @size: 15px, @family: 'os-semibolditalic');
      letter-spacing: 1px;
    }
  }

  .sx {
    border-right: 1px solid #ccc;
    margin-bottom: 15px;

    .descrizione {
      .set-font(@color: @rossoRiva, @size: 15px, @family: 'os-semibold');
      letter-spacing: 1px;
      margin-bottom: 20px;

      .fa-icon {
        float: right;
      }
    }

    .testata-sx {
      margin-bottom: 20px;

      .del {
        display: none;
      }

      .elemento {
        margin-bottom: 5px;

        .testata-label {
          .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
          text-align: right;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .testata-value {
          .custom-input {
            .el-input__inner {
              height: 22px !important;
              padding: 0 5px;
              border: 1px solid #dcdfe6;
            }
          }

          .custom-date-picker {
            .el-input__inner {

              height: 22px !important;
              padding-left: 30px !important;
              border: 1px solid #dcdfe6;
            }

            .el-input__inner:focus {
              border-color: @greenRiva;
            }

            .el-input__prefix {
              left: 0;
            }
          }

          .custom-select-el {
            .el-input__inner {
              height: 22px !important;
              line-height: 22px;
              border: 1px solid #dcdfe6;
              padding: 0 5px;
              letter-spacing: 0;
            }

            .is-disabled {
              .el-input__inner {
                background-color: #f5f7fa;
              }

              .el-input__inner:hover {
                border: 1px solid #dcdfe6 !important;
              }
            }
          }
        }

        .textarea {
          .el-textarea {
            textarea {
              //height: 80px;
            }
          }
        }

      }
    }


    .el-table {
      .el-table__header {
        .cell {
          &.header-add {
            padding: 0 !important;
          }

          .icona-add {
            color: @rossoRiva;
            float: right;
            font-size: 20px;
          }
        }
      }

      .el-table__body {
        .evidenziato {
          background-color: #daf5da;
        }

        .icone-div {
          display: flex;
          justify-content: flex-end;

          .icona {
            color: @rossoRiva;
            margin-left: 10px;
          }

          .icona-pv {
            color: #ccc;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .dx {
    margin-bottom: 15px;

    .titolo {
      .set-font(@color: #666, @size: 16px, @family: 'os-semibold');
      line-height: 16px;
    }

    .info-download {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;

      .nome-doc {
        .set-font(@color: #ccc, @size: 16px, @family: 'os-semibolditalic');
        letter-spacing: 1px;
      }
    }

    .info-upload {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;

      .custom-select-el {
        width: 240px;
      }
    }

    .nome-file {
      margin-top: 10px;
      height: 15px;
      line-height: 15px;
      .set-font(@color: #ccc, @size: 12px, @family: 'os-lightitalic');
    }

    .doc-container {

      // padding-top: 15px;
      .doc {
        height: 100%;
        width: 100%;
        border: 1px solid @grayMedium;
        border-style: dashed;

        .el-upload {
          display: block;
          margin: auto;
        }

        .add {
          margin-top: 20px;
          line-height: 30px;

          .add-icon {
            font-size: 35px;
            color: @rossoRiva;
          }

          .el-upload__text {
            .set-font(@size: 14px, @family: 'os-regular', @color: @rossoRiva);
          }
        }
      }

      .preview-img {
        height: 100%;
        width: 100%;
        border: 1px solid @grayMedium;
        border-style: dashed;

        img {
          display: block;
          margin-left: auto;
          margin-right: auto;
          max-width: 100%;
        }
      }

      .file-preview {
        height: 100%;
        width: 100%;
        border: 1px solid @grayMedium;
        border-style: dashed;
        position: relative;

        .delete {
          color: #666;
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 10;
        }

        canvas {
          height: 100% !important;
          width: unset !important;
          display: block !important;
          margin-left: auto;
          margin-right: auto;
          max-width: 100%;
        }

        img {
          display: block;
          margin-left: auto;
          margin-right: auto;
          max-width: 100%;
        }
      }
    }
  }

  .bottoni {
    text-align: right;
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 1249px) {
  .dettaglio-contestazione {
    .sx {
      border-right: 0 !important;
    }
  }
}

@media only screen and (max-width: 991px) {
  .dettaglio-contestazione {
    .testata-sx {
      .del {
        display: flex !important;
      }
    }

    .testata-dx {
      .del {
        display: none !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/Contestazioni/DettaglioContestazione.vue